import Helper from '@/Helper'
export default {
  getListGroupDocument (state, payload) {
    state.group_documents = payload
    state.total = payload.meta ? payload.meta.total : ''
    state.last_page = payload.meta ? payload.meta.last_page : ''
  },
  addRoot (state, payload) {
    state.group_documents.push(payload)
  },
  destroyGroupDocument (state, payload) {
    var data = []
    var items = []
    state.group_documents.forEach(element => {
      data = data.concat(Helper.getUnNestedChildren(element))
    })
    data.forEach(element => {
      if (parseInt(element.id) === parseInt(payload.id)) {
      } else {
        items.push(element)
      }
    })
    state.group_documents = Helper.getNestedChildren(items, 0)
  },
  addGroupDocumentChildren (state, payload) {
    var data = []
    state.group_documents.forEach(element => {
      data = data.concat(Helper.getUnNestedChildren(element))
    })
    data.push(payload)
    state.group_documents = Helper.getNestedChildren(data, 0)
  },
  updateGroupDocument (state, payload) {
    var data = []
    var items = []
    state.group_documents.forEach(element => {
      data = data.concat(Helper.getUnNestedChildren(element))
    })
    data.forEach(element => {
      if (parseInt(element.id) === parseInt(payload.id)) {
        element = payload
      }
      items.push(element)
    })
    state.group_documents = Helper.getNestedChildren(items, 0)
  }
}



// WEBPACK FOOTER //
// ./src/store/module/group-document/mutations.js